import React, { useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';

import { convertRelationsList } from '../../../utils/converters/convertListWithLocalization';
import { DEPENDENT_FORM_STEPS } from '../../../redux/dependentForm/progress.actions';
import {
  FAMILY_MEMBERS_OPTIONS,
  PARENT_OPTIONS,
} from '../../../constants/strings';
import { DEPENDENT_ROLES } from '../../../constants';
import { IDS } from '../../../constants/ids';
import SelectCustom from '../../SelectCustom';
import Button from '../../Button';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

const DependentRelation = ({
  goNext,
  titleWithRole,
  formatMessage,
  pending,
  isCareUserCreator,
  role,
}) => {
  const [relation, setRelation] = useState();
  const roleOptions = useMemo(() => {
    return role === DEPENDENT_ROLES.PARENT
      ? PARENT_OPTIONS
      : FAMILY_MEMBERS_OPTIONS;
  }, [role]);
  const options = convertRelationsList(roleOptions, formatMessage);
  usePageView('Add Dependent | Relationship');

  const handleRelationChange = option => setRelation(get(option, 'value'));

  const handleSubmit = e => {
    e.preventDefault();
    goNext({
      step: DEPENDENT_FORM_STEPS.RELATION,
      data: { role: relation },
    });
  };

  return (
    <div styleName="section">
      <MetaHelmet title="pages.title.dependentRelation" />
      {titleWithRole}
      <p styleName="sub-title">
        <If condition={isCareUserCreator}>
          {formatMessage({ id: 'dependent.form.relationshipSubTitle' })}
          <Else />
          {formatMessage({ id: 'dependent.form.relationshipExistSubTitle' })}
        </If>
      </p>

      <div styleName={cn('content', { disabled: pending })}>
        <form onSubmit={handleSubmit}>
          <SelectCustom
            id={IDS.FORM_FIELDS.RELATIONSHIP}
            onChange={handleRelationChange}
            multi={false}
            name="role"
            label={formatMessage({ id: 'dependent.form.relationshipLabel' })}
            options={options}
            placeholder={formatMessage({
              id: 'profile.fields.relationship.placeholder',
            })}
            value={relation}
            searchable={false}
          />

          <div styleName="btn-block">
            <Button
              className="mr3"
              id={IDS.ADD_DEPENDENT.NEXT}
              type="submit"
              raised
              color="primary"
              disabled={!relation || pending}
            >
              {formatMessage({ id: 'submit.fillProfile' })}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

DependentRelation.propTypes = {
  goNext: PropTypes.func,
  titleWithRole: PropTypes.node,
  formatMessage: PropTypes.func,
  pending: PropTypes.bool,
  isCareUserCreator: PropTypes.bool,
  role: PropTypes.string,
};

export default enhance(DependentRelation);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentRelation/index.jsx